export default __webpack_public_path__ + "static/media/unhallowedblight1.e704cba3.png";